import CustomerService from "../../views/modules/customer_service/CustomerService";
//import CollectionList from "../../views/modules/finances/collections/CollectionList";
import DocumentList from "../../views/modules/customer_service/documents/DocumentList";
import CustomersList from "../../components/customers/CustomersList";
import RequestList from "../../views/modules/technical_support/requests/RequestList";
import ComplaintList from "../../views/modules/customer_service/complaints/ComplaintList.vue";
//import KPI from "../../views/modules/customer_service/kpi/KPI";
import ContactList from "@/components/contacts/ContactList";
// reports
import CanceledContracts from "../../views/modules/customer_service/reports/CanceledContracts";
import Interactions from "../../views/modules/customer_service/reports/Interactions";
import layouts from "../../layout";
//import ClientWithoutCalling from "../../views/modules/customer_service/kpi/ClientWithoutCallingCustomer.vue";
//import ContactWithoutCalling from "../../views/modules/customer_service/kpi/ContactWithoutCallingCustomer.vue";
import roles from "@/roles";
import training from "../../views/modules/sales/training/mview/index";
import channelMview from "../../views/modules/sales/training/mview/channelMview.vue";
import store from "@/store";
import { COMPANYS } from "@/const";
//import Kpi from "../../views/modules/technical_support/KPI/Kpi";
import ChargesTab from "../../views/modules/finances/collections/ChargesTab";
import Record from "@/views/modules/automatic_processes/cut_and_reconnection/Record.vue";
import SLA from "@/views/modules/technical_support/KPI/SLA/KpiSoporteTecnico";
import Satisfacción from "@/views/modules/technical_support/KPI/Satisfaccion/KpiSatisfaccion";
//import ExcludedClientsFromPortalApp from "@/views/modules/customer_service/reports/ExcludedClientsFromPortalApp.vue";
import ReportRequestByTechnical from "@/views/modules/technical_support/reports/ReportRequestByTechnical.vue";
//import ReportSurvey from "@/views/modules/SurveyAnswer/ReportSurvey.vue";
export default {
  path: "/customer_service",
  name: "customer-service",
  component: CustomerService,
  meta: {
    auth: true
  },
  redirect: {
    name: "customer-service-customers"
  },
  children: [
    {
      path: "customers",
      name: "customer-service-customers",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Customers",
        tags: ["customerService", "customers"],
        index: true
      },
      children: [
        {
          path: "customers",
          name: "customer-service-customers",
          component: CustomersList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Customers",
            tags: ["customerService", "customers"],
            index: true
          }
        },
        {
          path: "kpi-sla-per-Customers",
          name: "customer-service-kpi-sla-per-Customers-in-customers",
          component: () =>
            import("@/views/modules/sales/kpi/SLAPorClienteKPI.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI SLA Por Clientes",
            tags: ["sales", "deals", "list", "SLA", "kpi", "customers"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-satisfaction-per-Customers",
          name: "customer-service-kpi-satisfaction-per-Customers-in-customers",
          component: () =>
            import("@/views/modules/sales/kpi/SatisfaccionPorClientesKPI"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Satisfaccion Por Clientes",
            tags: [
              "sales",
              "deals",
              "list",
              "satisfaction",
              "kpi",
              "customers"
            ],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }
      ]
    },
    {
      path: "contacts",
      name: "customer-service-contacts",
      component: ContactList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Contacts",
        tags: ["customer_service", "contacts"],
        index: true
      }
    },

    {
      path: "requests",
      name: "customer-service-external-requests",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Requests",
        tags: ["technicalSupport", "requests"],
        index: true
      },
      children: [
        {
          path: "external-requests",
          name: "customer-service-requests",
          component: RequestList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Requests",
            tags: ["customerService", "Requests"],
            index: true
          }
        },
        {
          path: "kpi-per-support",
          name: "customer-service-kpi-per-support",
          component: SLA,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Cumplimiento SLA",
            tags: ["customer-service", "sla", "list"],
            index: true
          }
        },
        {
          path: "kpi-per-satisfactions",
          name: "customer-service-kpi-per-satisfactions",
          component: Satisfacción,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Satisfactions KPI",
            tags: ["customer-service", "sla", "list"],
            index: true
          }
        }
      ]
    },

    {
      path: "complaints",
      name: "customer-service-complaints",
      component: ComplaintList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Complaints",
        tags: ["customerService", "complaints"],
        index: true
      }
    },
    {
      path: "finances-collections",
      name: "Customer-service-finances-collection",
      component: ChargesTab,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Collections",
        tags: ["finances", "collection"],
        index: true
      }
    },
    {
      path: "record-cut-and-reconnection-cobro",
      name: "record-cut-and-reconnection-cobro",
      component: Record,
      meta: {
        auth: true,
        title: "Record cut and reconnection",
        index: true
      }
    },

    /*
   {
      path: "collection-list",
      name: "collection-list",
      component: {
        name: "CollectionList",
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        title: "Collection List"
      },
      children: [
        {
          path: "collections",
          name: "customers-service-collections",
          component: CollectionList,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Collections",
            tags: ["customerService", "collections"],
            index: true
          }
        }
      ]
    },
    */
    {
      path: "reports",
      name: "customer-service-report",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        index: true
      },
      children: [
        {
          path: "canceled_contracts",
          name: "customer-service-report-canceled-contracts",
          component: CanceledContracts,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Canceled Contracts",
            tags: ["customerService", "canceledContracts", "reports"],
            index: true
          }
        },
        {
          path: "interactions",
          name: "customer-service-report-interactions",
          component: Interactions,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Interactions",
            tags: ["customerService", "interactions", "reports"],
            index: true
          }
        },
        {
          path: "report-client-with-or-without-app",
          name: "customer-service-report-client-with-or-without-app",
          component: () =>
            import(
              "@/views/modules/customer_service/reports/ReportClientsWithOrWithoutApp.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Report Clients with or without App",
            tags: [
              "customerService",
              "Clients with App",
              "Clients without App",
              "App",
              "reports"
            ],
            index: true
          }
        },
        /*
        {
          path: "excluded_clients_from_portal_app",
          name: "excluded_clients_from_portal_app",
          component: ExcludedClientsFromPortalApp,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Excluded Clients From Portal App",
            tags: ["customerService", "Excluded Clients", "reports"],
            index: true
          }
        },
        */
        /*
        {
          path: "report-devices-costumer_sevice",
          name: "report-devices-by-client-costumer_sevice",
          component: () =>
            import("../../views/modules/sales/reports/ReportDevicesByClients"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte Equipos Por Cliente",
            tags: ["report", "sales", "list", "devices"],
            index: true
          }
        }
        */
        {
          path: "RepoteSolicitudesporasignado",
          name: "customer-service-SolicitudesporAsignado",
          component: ReportRequestByTechnical,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Canceled Contracts",
            tags: [
              "customerService",
              "RepoteSolicitudesporasignado",
              "reports"
            ],
            index: true
          }
        }
      ]
    },
    {
      path: "documents",
      name: "customers-service-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["customers-service", "documents"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      }
    },
    /*
    {
      path: "kpi",
      name: "customer-kpi",
      component: KPI,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI",
        tags: ["customerService", "kpi"],
        index: true
      },
      children: [
        {
          path: "ClientWithoutCalling",
          name: "customer-service-kpi-missingCalling",
          component: ClientWithoutCalling,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Clientes sin llamar",
            tags: ["sales", "deals", "list"],
            index: true
          }
        },
        {
          path: "ContactWithoutCalling",
          name: "customer-service-kpi-missingCalling-Contact",
          component: ContactWithoutCalling,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Contactos sin llamar",
            tags: ["sales", "deals", "list"],
            index: true
          }
        }
      ]
    },

    {
      path: "kpisla-tecnical-support",
      name: "kpisla-tecnical-support",
      component: Kpi,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI",
        tags: ["support", "kpi"],
        index: true
      },
      children: [
        {
          path: "kpi-per-sla",
          name: "kpi-sla",
          component: () =>
            import(
              "../../views/modules/technical_support/KPI/SLA/KpiSoporteTecnico"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Cumplimiento SLA",
            tags: ["support", "sla", "list"],
            index: true
          }
        },
        {
          path: "kpi-per-satisfactions",
          name: "kpi-satisfaction",
          component: () =>
            import(
              "../../views/modules/technical_support/KPI/Satisfaccion/KpiSatisfaccion"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Satisfactions KPI",
            tags: ["support", "sla", "list"],
            index: true
          }
        },
        {
          path: "kpi-sla-per-Customers-customerService",
          name: "sales-kpi-sla-per-Customers-customerService",
          component: () =>
            import("@/views/modules/sales/kpi/SLAPorClienteKPI.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI SLA Por Clientes",
            tags: ["sales", "deals", "list", "SLA", "kpi", "customers"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        },
        {
          path: "kpi-satisfaction-per-Customers-customerService",
          name: "sales-kpi-per-Customers-customerService",
          component: () =>
            import("@/views/modules/sales/kpi/SatisfaccionPorClientesKPI"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Satisfaccion Por Clientes",
            tags: [
              "sales",
              "deals",
              "list",
              "satisfaction",
              "kpi",
              "customers"
            ],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ]
          }
        }
      ]
    },
    */
    {
      path: "training",
      name: "training",
      component: training,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Entrenamientos",
        tags: ["training"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "customer-service-training-magytrack",
          name: "customer-service-training-traning-magytrack",
          component: () =>
            import(
              "../../views/modules/customer_service/training/magytrack/Magytrack"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "magytrack",
            tags: ["customer_service", "training", "magytrack"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.MTR
          },
          children: [
            {
              path: "customer-service-user-manual",
              name: "customer-service-training-user-manual",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magytrack/userManualMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["customer_service", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-link-channel-magytrack",
              name: "customer-service-training-link-channel-magytrack",
              component: channelMview,
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["customer_service", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-mview-magytrack",
              name: "customer-service-training-magytrack-contract",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magytrack/contractMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["customer_service", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-test-magytrack",
              name: "customer-service-training-test-magytrack",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magytrack/testMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["customer_service", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer_service-presentation-magytrack",
              name: "customer-service-training-presentation-magytrack",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magytrack/presentationMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["customer_service", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-product-presentation-magytrack",
              name: "customer-service-training-product-presentation-magytrack",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magytrack/presentationProductMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: [
                  "customer_service",
                  "training",
                  "presentationProductmagytrack"
                ],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-price-list-magytrack",
              name: "customer-service-training-price-list-magytrack",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magytrack/priceListMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["customer_service", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-model-contract-magytrack",
              name: "customer-service-training-model-contract-magytrack",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magytrack/contractMagytrack"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["customer_service", "training", "magytrack"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "customer-service-training-mview",
          name: "customer-service-traning-mview",
          component: {
            render: (h) => h("router-view")
          },
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Mview",
            tags: ["customer_service", "training", "Mview"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "customer-service-user-manual",
              name: "customer-service-training-user-manual-mview",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/mview/userManualMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["customer_service", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-link-channel-mview",
              name: "customer-service-training-link-channel-mview",
              component: channelMview,
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["customer_service", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-mview-contract",
              name: "customer-service-training-mview-contract",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/mview/contractMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["customer_service", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-test-mview",
              name: "customer-service-training-test-mview",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/mview/testMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["customer_service", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-presentation-mview",
              name: "customer-service-training-product-presentation-mview",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/mview/presentationMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["customer_service", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "product-presentation-mview",
              name: "customer-service-training-product-presentation-mview",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/mview/presentationProductMview.vue"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: [
                  "customer_service",
                  "training",
                  "presentationProductMview"
                ],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-price-list-mview",
              name: "customer-service-training-price-list-mview",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/mview/priceListMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["customer_service", "training", "priceListMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-model-contract-mview",
              name: "customer-service-training-model-contract-mview",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/mview/modelContractMview"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["customer_service", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "customer-service-training-mpago",
          name: "customer-service-training-mpago",
          component: () =>
            import(
              "../../views/modules/customer_service/training/magypago/Mpago"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Mpago",
            tags: ["customer_service", "training", "mpago"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "customer-service-user-manual-mpago",
              name: "customer-service-training-user-manual-mpago",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/userManualMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["customer_service", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-link-channel-mpago",
              name: "customer-service-training-link-channel-mpago",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/channelMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["customer_service", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-mview-contract",
              name: "customer-service-training-mpago-contract",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/contractMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["customer_service", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-mview-contract",
              name: "customer-service-training-mpago-terminalManual",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["customer_service", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-test-mpago",
              name: "customer-service-training-test-mpago",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/testMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["customer_service", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-presentation-mpago",
              name: "customer-service-training-presentation-mpago",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/presentationMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["customer_service", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-product-presentation-mpago",
              name: "customer-service-training-product-presentation-mpago",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/presentationProductMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: [
                  "customer_service",
                  "training",
                  "presentationProductMview"
                ],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-price-list-mpago",
              name: "customer-service-training-price-list-mpago",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/priceListMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["customer_service", "training", "priceListMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-model-contract-mpago",
              name: "customer-service-training-model-contract-mpago",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magypago/modelContractMpago"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["customer_service", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "customer-service-training-magyloterry",
          name: "customer-service-training-magyloterry",
          component: () =>
            import(
              "../../views/modules/customer_service/training/magyloterry/magyloterry"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Magyloterry",
            tags: ["customer_service", "training", "magylottery"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "customer-service-user-manual",
              name: "customer-service-training-user-manual-Lottery",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/userManualLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["customer_service", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-link-channel-loterry",
              name: "customer-service-training-link-channel-Lottery",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/channelLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["customer_service", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-mview-contract",
              name: "customer-service-training-Lottery-contract",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/contractLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["customer_service", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-mview-contract",
              name: "customer-service-training-Lottery-terminalManual",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["customer_service", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-test-mpago",
              name: "customer-service-training-test-Lottery",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/testLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["customer_service", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-presentation-Lottery",
              name: "customer-service-training-presentation-Lottery",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/presentationLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["customer_service", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-product-presentation-Lottery",
              name: "customer-service-training-product-presentation-Lottery",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/presentationProductLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: [
                  "customer_service",
                  "training",
                  "presentationProductMview"
                ],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-price-list-Lottery",
              name: "customer-service-training-price-list-Lottery",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/priceListLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["customer_service", "training", "priceListLottery"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-model-contract-Lottery",
              name: "customer-service-training-model-contract-Lottery",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/magyloterry/modelContractLottery"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["customer_service", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        },
        {
          path: "customer-service-training-seahourse",
          name: "customer-service-training-seahourse",
          component: () =>
            import(
              "../../views/modules/customer_service/training/seahourse/seahourse"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Seahourse",
            tags: ["customer_service", "SEAHORSE", "training"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          },
          children: [
            {
              path: "customer-service-user-manual",
              name: "customer-service-training-user-manual-seahourse",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/userManualseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual de Usuario",
                tags: ["customer_service", "training", "userManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-link-channel-seahourse",
              name: "customer-service-training-link-channel-seahourse",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/channelseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Canal de Youtube",
                tags: ["customer_service", "training", "channelMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-seahourse-contract",
              name: "customer-service-training-seahourse-contract",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/contractseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Contrato",
                tags: ["customer_service", "training", "contractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-seahourse-contract",
              name: "customer-service-training-seahourse-terminalManual",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/terminalManual"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Manual uso terminal",
                tags: ["customer_service", "training", "terminalManual"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-test-seahourse",
              name: "customer-service-training-test-seahourse",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/testseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Evaluación",
                tags: ["customer_service", "training", "testMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-presentation-seahourse",
              name: "customer-service-training-presentation-seahourse",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/presentationseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación de venta",
                tags: ["customer_service", "training", "presentationMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-product-presentation-seahourse",
              name: "customer-service-training-product-presentation-seahourse",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/presentationProductseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Presentación del producto",
                tags: [
                  "customer_service",
                  "training",
                  "presentationProductMview"
                ],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-price-list-seahourse",
              name: "customer-service-training-price-list-seahourse",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/priceListseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Lista de precios",
                tags: ["customer_service", "training", "priceListLottery"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            },
            {
              path: "customer-service-model-contract-seahourse",
              name: "customer-service-training-model-contract-seahourse",
              component: () =>
                import(
                  "../../views/modules/customer_service/training/seahourse/modelContractseahourse"
                ),
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Modelo de contrato",
                tags: ["customer_service", "training", "modelContractMview"],
                index: true,
                roles: [
                  roles.SoporteVentas,
                  roles.EjecutivoDeVentas,
                  roles.CEO,
                  roles.SuperUsuario
                ]
              }
            }
          ]
        }
      ]
    },

    {
      path: "create-notification-invoice",
      name: "customer-service-notification",
      component: () =>
        import(
          "@/components/customer_service/Notificaciones/Notificaciones.vue"
        ),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Notification",
        tags: ["customerService", "Notification"],
        index: false,
        roles: [roles.EnvioNotificacionCliente],
        role: 55
      }
    },
    {
      path: "Notification-billing",
      name: "customer-service-notificationBilling",
      component: () =>
        import(
          "@/components/customer_service/Notificaciones/NotificationFacturalNavixy.vue"
        ),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Notificaciones de facturacion Navixy",
        tags: ["customerService", "FacturacionNavixy"],
        index: false,
        roles: [roles.EnvioNotificacionCliente],
        role: 55
      }
    },
    {
      path: "Notification-magypago-billing",
      name: "customer-service-notificationmagyBilling",
      component: () =>
        import(
          "@/components/customer_service/Notificaciones/Notificaciones_magypago.vue"
        ),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Notificaciones de facturacion en Magypago",
        tags: ["customerService", "FacturacionNavixy"],
        index: true
      }
    },
    {
      path: "formcustomer",
      name: "customer-service-formcustomer",
      component: () =>
        import(
          "@/components/customer_service/customer_survey/SurveyCustomer.vue"
        ),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Formulario para encuentas",
        // tags: ["customerService", "FacturacionNavixy"],
        index: true
      }
    },
    // {
    //   path: "reportsurveycustomers",
    //   name: "employeescustomers-reportsurvey",
    //   component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Respuesta de Empleados",
    //     index: true,
    //     // Pass props to the componentd
    //     module: "value1",
    //     props: {
    //       // Define your props here
    //       // prop2: "value2"
    //       // ...,
    //     }
    //   }
    // },
    {
      path: "reportsurvey",
      name: "customers-reportsurvey",
      component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Respuesta de Clientes",
        index: true,
        roles: [roles.EncuestaClientes, roles.CEO, roles.SuperUsuario],

        // Pass props to the componentd
        module: "value1",
        props: {
          // Define your props here
          // prop2: "value2"
          // ...,
        }
      }
    }
  ]
};
